import { createSlice } from '@reduxjs/toolkit';

const categorySlice = createSlice({
    name: 'category',
    initialState: { searchText: '' },
    reducers: {
        setSearch: (state, action) => Object.assign(state, { searchText: action.payload })
    }
});

export const { setSearch } = categorySlice.actions;
export default categorySlice.reducer;
